
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnowShowersDayColour as ObiHeavySnowShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow-showers-day-colour.js';
 
 
 

 
 export const ObiHeavySnowShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-heavy-snow-showers-day-colour',
   elementClass: ObiHeavySnowShowersDayColourElement,
   events: {
     
   }
  });
 
 